import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { AuthenticationService, UserService } from "src/app/core/services";
import { WeeklyData, DashboardRodListResponseDto } from "src/app/shared/dto";
import { filter as lodashFilter} from 'lodash-es';
import { DatePipe } from "@angular/common";
import { RoDs } from "src/app/shared/services/rods.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { formatRodListName } from "src/app/shared/helpers";

@UntilDestroy()
@Component({
    selector: 'app-rod-card',
    templateUrl: './rod-card.component.html',
    styleUrls: ['../../common-reporting-dashboard.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatePipe],
    standalone: false
})

export class RodCardComponent {
    @Input() isLoading: boolean;
    @Input() set rodData(value: WeeklyData[]) {
        if (value) {
            this._innerRodData = value;
            this.updateChartData();
        }
    }

    get rodData(): WeeklyData[] {
        return this._innerRodData;
    }

    @Output() userScopeChange = new EventEmitter<boolean>();

    chartData: number[] = [];
    totalMinutesSaved: number = 0;
    departmentList: string[] = [];
    rodList: DashboardRodListResponseDto[] = [];
    selectedScope: 'all' | 'current' = 'all';
    private _innerRodData: WeeklyData[];

    constructor(private readonly authenticationService: AuthenticationService, private readonly datePipe: DatePipe, private readonly rods: RoDs, private readonly userService: UserService) {
        this.rods.getRods().pipe(untilDestroyed(this)).subscribe((data) => {
            this.rodList = lodashFilter(data, item => item['status'] === 'Completed' && item['processedContactsMatchIds'].length > 0).map((item) => {
                return {
                    ...item,
                    name: formatRodListName(item),
                };
            });
        });
    }

    updateChartData(): void {
        this.departmentList = this._innerRodData?.map(d => {
            let formattedDate = this.datePipe.transform(d.weekStart, 'MM/dd/yy');
            return formattedDate;
        }).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
        this.chartData = this._innerRodData?.map(d => d.contactMatchCount);
        this.totalMinutesSaved = this.chartData.reduce((total, num) => total + num, 0) * 22;
    }

    onUserScopeChange(value: 'all' | 'current'): void {
        this.selectedScope = value;
        this._innerRodData = undefined;
        const includeAllUsers = value === 'all';
        this.userScopeChange.emit(includeAllUsers);
    }
}
